<script setup>
import { useLocationStore } from "@/stores/locations"
import axios from "axios"
import * as d3 from "d3"
import * as L from "leaflet"
import { onMounted, watch } from "vue"

let eqmap
let geoJson
const color_scale = d3.scaleLinear().domain([0, 8]).range(["#fabb0a", "#cc0006"])
const size_scale = d3.scaleLinear().domain([0, 8]).range([4, 25])
const geojsonMarkerOptions = {
  radius: 10,
  fillColor: "#000",
  color: "#000",
  fillOpacity: 0.5,
}
const mainStore = useLocationStore()

// mainStore.$subscribe((mutation, state) => {
//   console.log(mutation, state)
//   // if (mutation.storeId === "locations") popGeoJson(state.filteredData)
// })

watch(
  () => mainStore.filteredData,
  () => {
    popGeoJson(mainStore.filteredData)
  }
)
watch(
  () => mainStore.selectedLocation,
  (n) => {
    // console.log(n.geometry.coordinates, o.geometry.coordinates)
    const latlng = new L.LatLng(n.geometry.coordinates[1], n.geometry.coordinates[0])
    const desc = getDescription(n)
    L.popup().setLatLng(latlng).setContent(desc).openOn(eqmap)
    eqmap.setView(latlng, eqmap.getZoom())
  }
)

function getDescription(n) {
  let desc = ""
  if (n && n.properties && n.geometry.coordinates) {
    const p = n.properties
    let depth = n.geometry.coordinates ? n.geometry.coordinates[2] : null
    depth = depth ? `${depth.toFixed(1)} km` : ""
    desc = `
            <h5>Mag: ${p.mag}, ${depth}</h5>
            <p>${p.place}</p>
            <p>${new Date(p.time).toLocaleString()}</p>
          `
  }
  return desc
}
function getColor(d) {
  return color_scale(String(d))
}

function getSize(d) {
  // return 5;
  return size_scale(String(d))
}

function filterFn() {
  const filteredData = mainStore.locations
  // console.time("filterFn")
  mainStore.filteredData = filteredData
  // console.timeEnd("filterFn")
  popGeoJson(filteredData)
}

const getEQData = async () => {
  mainStore.isLoading = true
  try {
    const data = await axios.get(
      // `https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_hour.geojson`
      `https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_day.geojson`
      // `https://earthquake.usgs.gov/earthquakes/feed/v1.0/summary/all_week.geojson`
    )
    // store.dispatch("addLocations", features)
    const features = data.data.features.map((f) => {
      if (f.properties.mag) f.properties.mag = Number(f.properties.mag.toFixed(1))
      return f
    })
    mainStore.locations = features

    const plate = await axios.get(
      `https://raw.githubusercontent.com/fraxen/tectonicplates/master/GeoJSON/PB2002_boundaries.json`
    )

    const tectoniLines = {
      color: "#964B00",
      weight: 1,
      opacity: 0.65,
    }
    L.geoJSON(plate.data, {
      style: tectoniLines,
    }).addTo(eqmap)
    filterFn()
  } catch (err) {
    console.log(err.message)
  }
}

function popGeoJson(features) {
  // console.time("popGeoJson")
  if (geoJson) eqmap.removeLayer(geoJson)
  geoJson = L.geoJSON(features, {
    pointToLayer: (feature, latlng) => {
      if (feature.properties.mag && parseFloat(feature.properties.mag)) {
        geojsonMarkerOptions.fillColor = getColor(feature.properties.mag)
        geojsonMarkerOptions.color = getColor(feature.properties.mag)
        geojsonMarkerOptions.radius = getSize(feature.properties.mag)
        return L.circleMarker(latlng, geojsonMarkerOptions)
      }
    },
  })
    .bindPopup((layer) => getDescription(layer.feature))
    .addTo(eqmap)
  if (features.length > 0) eqmap.fitBounds(geoJson.getBounds())
  // console.timeEnd("popGeoJson")
  mainStore.isLoading = false
}
onMounted(() => {
  eqmap = L.map("eqmap").setView([0, 0], 2)

  L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
    maxZoom: 10,
    attribution: "© OpenStreetMap",
  }).addTo(eqmap)

  getEQData()
})
</script>

<template>
  <div class="map-chart">
    <div id="eqmap"></div>
  </div>
</template>
